import type { FilterRangePreset } from "@/features/filters/components/filter-range/filter-range.types";

type DietPriceRangePresetLabels = {
  below30: string;
  between30And60: string;
  between60And80: string;
  above80: string;
};

export const getDietPriceRangePresets = ({
  labels,
  maxValue,
  locale,
}: {
  labels: DietPriceRangePresetLabels;
  maxValue: number;
  locale: string;
}): FilterRangePreset[] => [
  {
    label: labels.below30,
    min: 0,
    max: locale === "cz" ? 350 : 30,
  },
  {
    label: labels.between30And60,
    min: locale === "cz" ? 350 : 30,
    max: locale === "cz" ? 500 : 60,
  },
  {
    label: labels.between60And80,
    min: locale === "cz" ? 500 : 60,
    max: locale === "cz" ? 600 : 80,
  },
  {
    label: labels.above80,
    min: locale === "cz" ? 600 : 80,
    max: maxValue,
  },
];
